package com.routexk.quiz.ui.sections.footer

import com.routexk.quiz.ui.utils.Constants
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.*

val FooterStyle = CssStyle.base {
    Modifier
        .fillMaxWidth()
        .padding(topBottom = 3.cssRem, leftRight = 2.cssRem)
}

val FooterLinkStyle = CssStyle {
    base {
        Modifier
            .fontSize(0.9.cssRem)
            .cursor(Cursor.Pointer)
            .textDecorationLine(TextDecorationLine.None)
            .transition(Transition.of("opacity", Constants.ANIMATION_FAST.ms))
    }
    hover {
        Modifier.opacity(0.7)
    }
}

val SocialIconStyle = CssStyle {
    base {
        Modifier
            .size(36.px)
            .borderRadius(50.percent)
            .cursor(Cursor.Pointer)
            .transition(
                Transition.of("transform", Constants.ANIMATION_FAST.ms),
                Transition.of("background-color", Constants.ANIMATION_FAST.ms)
            )
    }
    hover {
        Modifier.scale(1.15)
    }
}
